import React, { Component } from "react";
import {
  NormalButton,
  TableWrapper,
  NormalTable,
  NormalCheckbox,
  NormalInput,
  NormalModal,
  NormalButtonBackend,
} from "component/common";
import { withTranslation } from "react-i18next";
import {
  Occupationtypes,
  NewOccupationtypes,
  updateCommon,
} from "redux/actions/Backend";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Toast } from "service/toast";
import { BsPencilSquare } from "react-icons/bs";
import closeIcon from "assets/images/close.png";

export class OccupationTypeClass extends Component {
  state = {
    OccupationDetails: [
      { label: "Code", divClass: "justify-content-end" },
      { label: "Name" },
      { label: "Active" },
      { label: "Action", divClass: "justify-content-center" },
    ],
    List: [],
    is_loading: false,
    isAboutPopModal: false,
    isNewdescPopModal: false,
    newid: null,
    newval: null,
    editid: null,
    editval: null,
    activeitem: true,
  };

  componentDidMount = () => {
    this.Listofoccuption({});
  };

  updateState = (data) => {
    if (this.state.isMounted) this.setState(data);
  };

  aboutpopup() {
    this.setState({
      isAboutPopModal: !this.state.isAboutPopModal,
    });
  }

  newdescpopup() {
    let { List, newid, te } = this.state;
    if (List.length > 0) {
      te = List[List.length - 1].occupationCode;
      console.log(te);
      newid = Number(te) + 1;
    } else {
      newid = 100001;
    }
    console.log(newid);
    this.setState({
      isNewdescPopModal: !this.state.isNewdescPopModal,
      newid,
    });
  }

  handledesc = ({ target: { value, name } }) => {
    console.log(name);
    let { editval, newid } = this.state;

    if ((name = "name")) {
      editval = value;
      this.setState({ editval });
    }
    if ((name = "newid")) {
      newid = value;
      this.setState({ newid });
    }
  };

  handledescription = ({ target: { value, name } }) => {
    let { newval } = this.state;

    if ((name = "newdescval")) {
      newval = value;
      this.setState({ newval });
    }
  };

  handleEdit(id, desc, check) {
    let { editid, editval, activeitem } = this.state;
    editid = id;
    editval = desc;
    activeitem = check;
    console.log(editid, editval);
    this.setState({
      editid,
      editval,
      activeitem,
    });
    this.aboutpopup();
  }

  Listofoccuption = async () => {
    this.updateState({ is_loading: true });
    await this.props.Occupationtypes().then((res) => {
      console.log(res);
      let { List } = this.state;

      List = res;
      console.log(List);
      this.setState({
        List,
        is_loading: false,
      });
      console.log(List.length);
    });
  };

  createdesc = async (id, val) => {
    console.log(id, val);
    if (val == null) {
      Toast({
        type: "error",
        message: "Description required",
      });
    } else {
      let { newval } = this.state;
      let newreason = {
        occupationDesc: val,
        occupationCode: id,
        occupationIsactive: true,
      };
      await this.props
        .NewOccupationtypes(newreason)
        .then((data) => {
          this.Listofoccuption({});
        })
        .catch((e) => console.log(e));
      this.newdescpopup();
      newval = "";
      this.setState({ newval });
    }
  };

  finaldesc = async (id, desc) => {
    let { editval, newval, newid, activeitem } = this.state;
    let descJson = {
      occupationDesc: desc,
      occupationCode: id,
      occupationIsactive: activeitem,
    };
    await this.props
      .updateCommon(
        `Occupationtypes/update?where=%7B%22occupationCode%22%3A%20${id}%7D
    `,
        descJson
      )
      .then((data) => {
        this.Listofoccuption({});
        Toast({
          type: "success",
          message: "Updated Successfully",
        });
      });
    this.aboutpopup();
    editval = "";
    newval = "";
    newid = "";
    this.setState({ editval, newval, newid });
  };

  handlecheckbox = async (item) => {
    let { List } = this.state;
    for (let i = 0; i <= List.length - 1; i++) {
      if (List[i].occupationCode == item) {
        List[i].occupationIsactive = !List[i].occupationIsactive;
        let descJson = {
          occupationDesc: List[i].occupationDesc,
          occupationCode: List[i].occupationCode,
          occupationIsactive: List[i].occupationIsactive,
        };
        await this.props
          .updateCommon(
            `Occupationtypes/update?where=%7B%22occupationCode%22%3A%20${item}%7D
  `,
            descJson
          )
          .then((data) => {
            this.Listofoccuption({});
          });
      }
    }
  };
  render() {
    let {
      OccupationDetails,
      List,
      is_loading,
      isAboutPopModal,
      editid,
      editval,
      newid,
      newval,
      isNewdescPopModal,
    } = this.state;
    let { t } = this.props;
    return (
      <>
        <div className="container-fluid department-container bg-white">
          <div className="row">
            <div className={"itemmaster-container col-12"}>
              <div className="row align-items-center">
                <div className="col-12 p-0">
                  <h4 className="label-head text-center text-md-left mt-3 mb-0">{t("Occupation Type")}</h4>
                </div>
              </div>
              <div className="tab-table-content">
                <p className="mt-3 label-title text-center text-md-left">{t("List of Occupation")}</p>
                <div className="py-4">
                  <div className="table-container">
                    <NormalTable headerDetails={OccupationDetails}>
                      {is_loading ? (
                        <tr>
                          <td colSpan="7">
                            <div class="d-flex mt-5 align-items-center justify-content-center">
                              <div class="spinner-border" role="status">
                                <span class="sr-only">Loading...</span>
                              </div>
                            </div>
                          </td>
                        </tr>
                      ) : List.length > 0 ? (
                        List.map(
                          (
                            {
                              occupationCode,
                              occupationDesc,
                              occupationIsactive,
                            },
                            index
                          ) => {
                            return (
                              <tr key={index}>
                                <td>
                                  <div className="text-left">
                                    {occupationCode}
                                  </div>
                                </td>
                                <td>
                                  <div className="text-left">
                                    {occupationDesc}
                                  </div>
                                </td>
                                <td>
                                  <div className="text-left">
                                    <NormalCheckbox
                                      checked={occupationIsactive}
                                      name="checked"
                                      onChange={() =>
                                        this.handlecheckbox(occupationCode)
                                      }
                                    />
                                  </div>
                                </td>
                                <td>
                                  <div className="text-left">
                                    <BsPencilSquare
                                      size={20}
                                      onClick={() =>
                                        this.handleEdit(
                                          occupationCode,
                                          occupationDesc,
                                          occupationIsactive
                                        )
                                      }
                                    />
                                  </div>
                                </td>
                              </tr>
                            );
                          }
                        )
                      ) : null}
                    </NormalTable>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="mt-3 col-12 col-md-3">
            <NormalButtonBackend
              mainbg={true}
              label={"Add Row"}
              onClick={() => this.newdescpopup()}
            />
          </div>
        </div>

        <NormalModal
          className={"retail-price-modal"}
          style={{ minWidth: "80%" }}
          modal={isAboutPopModal}
          handleModal={() => this.aboutpopup()}
        >
                    <div className="col-12 mx-auto">
            <div className="d-flex justify-content-end">
            <img
                onClick={() => this.aboutpopup()}
                className="close"
                src={closeIcon}
                alt=""
              />
            </div>
          </div>
          <div className="col-12">
            <div className="text-center">
            <h5> EDIT DESCRIPTION </h5>
            </div>
              <div className="col-12">
                <div className="">
                <h6>Code</h6>
                <NormalInput value={editid} disabled={true} />
              </div>
              <div className="mt-2">
                <h6>Description</h6>
                <NormalInput
                  value={editval}
                  name="name"
                  onChange={this.handledesc}
                />
              </div>
              <div className="d-flex mt-4">
                <div className="col-6">
                  <NormalButtonBackend
                    normal={true}
                    label="Cancel"
                    onClick={() => this.aboutpopup()}
                  />
                </div>
                <div className="col-6">
                  <NormalButtonBackend
                    normal={true}
                    label="Done"
                    onClick={() => this.finaldesc(editid, editval)}
                  />
                </div>
              </div>
            </div>
          </div>
        </NormalModal>
        <NormalModal
          className={"retail-price-modal"}
          style={{ minWidth: "80%" }}
          modal={isNewdescPopModal}
          handleModal={() => this.newdescpopup()}
        >
            <div className="col-12 mx-auto">
            <div className="d-flex justify-content-end">
            <img
                onClick={() => this.newdescpopup()}
                className="close"
                src={closeIcon}
                alt=""
              />
            </div>
          </div>
          <div className="col-12">
            <div className="text-center">
            <h5> ADD Adjustment Reason </h5>
            </div>
              <div className="col-12">
                <div className="">
                <h6>Code</h6>
                <NormalInput
                  value={newid}
                  name="newid"
                  onChange={this.handledesc}
                />
              </div>
              <div className="mt-2">
                <h6>Description</h6>
                <NormalInput
                  value={newval}
                  name="newdescval"
                  onChange={this.handledescription}
                />
              </div>
              <div className="d-flex mt-4">
                <div className="col-6">
                  <NormalButtonBackend
                    normal={true}
                    label="Cancel"
                    onClick={() => this.newdescpopup()}
                  />
                </div>
                <div className="col-6">
                  <NormalButtonBackend
                    normal={true}
                    label="Done"
                    onClick={() => this.createdesc(newid, newval)}
                  />
                </div>
              </div>
            </div>
          </div>
        </NormalModal>
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      Occupationtypes,
      NewOccupationtypes,
      updateCommon,
    },
    dispatch
  );
};
export const OccupationType = withTranslation()(
  connect(null, mapDispatchToProps)(OccupationTypeClass)
);
